export enum TeamMemberType {
    Internal = 1,
    External = 2,
}

export enum InternalTeamMemberRole {
    CorpDev = 1,
    Analyst = 2,
    Operations = 3,
    Legal = 4,
    PrimaryMember = 5,
}

export enum ExternalTeamMemberRole {
    Qoe = 1,
    LegalCounsel = 2,
    BenefitsAndInsuranceConsulting = 3,
}

export enum InternalPermissions {
    ReadOnly = 1,
    ReadOnlyAndCommunicate = 2,
    ReadOnlyAndCommunicateAndExecute = 3,
}

export enum ExternalPermissions {
    Vdr = 1,
    VdrAndCommunicate = 2,
    VdrAndReadOnlyCommunicate = 3,
}

export const TeamMemberTypeOptionList = [
    { value: TeamMemberType.Internal, label: 'Internal' },
    { value: TeamMemberType.External, label: 'External' },
];

export const InternalTeamMemberRoleOptionList = [
    { value: InternalTeamMemberRole.CorpDev, label: 'Biz/Corp Dev' },
    { value: InternalTeamMemberRole.Analyst, label: 'Analyst' },
    { value: InternalTeamMemberRole.Operations, label: 'Operations' },
    { value: InternalTeamMemberRole.Legal, label: 'Legal' },
    { value: InternalTeamMemberRole.PrimaryMember, label: 'Primary Member' },
];

export const ExternalTeamMemberRoleOptionList = [
    { value: ExternalTeamMemberRole.Qoe, label: 'QOE' },
    { value: ExternalTeamMemberRole.LegalCounsel, label: 'Legal Counsel' },
    { value: ExternalTeamMemberRole.BenefitsAndInsuranceConsulting, label: 'Benefits & Insurance Consulting' },
];

export const InternalPermissionsOptionList = [
    { value: InternalPermissions.ReadOnly, label: 'Level 1 — Read Only', shortLabel: 'Level 1' },
    { value: InternalPermissions.ReadOnlyAndCommunicate, label: 'Level 2 — Read Only & Communicate', shortLabel: 'Level 2' },
    { value: InternalPermissions.ReadOnlyAndCommunicateAndExecute, label: 'Level 3 — Read Only, Communicate, & Execute', shortLabel: 'Level 3' },
];

export const ExternalPermissionsOptionList = [
    { value: ExternalPermissions.Vdr, label: 'Level 1 — VDR', shortLabel: 'Level 1' },
    { value: ExternalPermissions.VdrAndCommunicate, label: 'Level 2 — VDR & Communicate', shortLabel: 'Level 2' },
    { value: ExternalPermissions.VdrAndReadOnlyCommunicate, label: 'Level 3 — VDR & Read Only Communicate', shortLabel: 'Level 3' },
];
